import { render } from "./ZoneWizardLaunchZone.vue?vue&type=template&id=09060e48&scoped=true"
import script from "./ZoneWizardLaunchZone.vue?vue&type=script&lang=js"
export * from "./ZoneWizardLaunchZone.vue?vue&type=script&lang=js"

import "./ZoneWizardLaunchZone.vue?vue&type=style&index=0&id=09060e48&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09060e48"]])

export default __exports__